module.exports = __webpack_public_path__ + "static/media/BotBody.e7aefdee.glb";